export enum LeadStatus {
  ALL = 'ALL',
  CLOSED = 'CLOSED',
  ACTIVE = 'ACTIVE'
}
